import React from 'react';
import { Container } from 'react-bootstrap';

const CenteredSection = ({ children, bg = 'white', maxWidth = '960px', className = '', ...rest }) => {
    return (
        <section className={`py-5 bg-${bg} ${className}`} {...rest}>
            <Container style={{ maxWidth }}>
                {children}
            </Container>
        </section>
    );
};

export default CenteredSection;
